import React from 'react';

const Home = () => {
    return (
        <section className='grid justify-center items-center h-screen relative bg-gray-800 bg-opacity-90'>
            <img src='https://i.ibb.co/jJ99BkR/background.jpg' alt='background' className='absolute h-screen w-screen opacity-10' />
            <div className='text-center relative z-20'>
                <h1 className='text-5xl font-bold mb-4 text-gray-300'>Md. <span className='text-green-500'>Sindabad</span></h1>
                <h4 className='text-gray-300'>Front End Developer</h4>
            </div>
        </section>
    )
}

export default Home;
